import React, { useMemo, useState, useEffect } from "react";
import { Tooltip, Input } from "antd";
import { numberRound, returnEuroString } from "../../../../../../helpers/Utils";
import { IconDot } from "../../../../../Layout/Icons";
import { CheckBoxInput } from "../../../../Buttons";
import { have_product_reference } from "../../../../../../helpers/OrdersFunctionsGlobal";

export default function MoneyRefundOrderRowPreview({
  type = "basic",
  o_rows,
  setValue,
  order_rows_selected,
  order_cart_rules = [],
}) {
  if (!Array.isArray(o_rows)) return null;
  const order_rows = o_rows;
  const [productReferences, setProductReferences] = useState({});

  useEffect(() => {
    const selectedReferences = {};
    order_rows_selected?.forEach((id) => {
      const selectedRow = order_rows?.find((row) => row.id === id);
      if (selectedRow) {
        selectedReferences[id] = selectedRow.product_reference;
      }
    });
    setProductReferences((prev) => ({
      ...prev,
      ...selectedReferences,
    }));
  }, [order_rows_selected, order_rows]);

  const handleInputChange = (id, value) => {
    setProductReferences((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const texts = useMemo(() => {
    return {
      tooltip_text:
        type == "basic"
          ? ""
          : type == "success"
          ? "Sent to bank"
          : "Not sent to bank",
      container_class:
        type == "basic"
          ? "bg-light-primary"
          : type == "success"
          ? "bg-green-light"
          : "bg-red-light",
      text_class: type == "success" ? "text-info" : "text-danger",
    };
  }, [type]);

  return (
    <div className={`${texts.container_class} rounded`}>
      {order_rows
        ?.filter((order_row) => order_row !== undefined)
        ?.map((d, idx) => (
          <div
            key={d.ui_row_key || `${d.id}_${idx}`}
            className={`${setValue ? "cursor-pointer" : ""} px-3 py-2`}
            onClick={
              setValue
                ? (e) => {
                    e.stopPropagation();
                    const current = order_rows_selected || [];
                    const or = current.includes(d.id)
                      ? current.filter((e) => e !== d.id)
                      : [...current, d.id];
                    const sum = numberRound(
                      order_rows
                        ?.filter((d) => or?.includes(d.id))
                        ?.reduce(
                          (total, cur) =>
                            +cur.unit_price_tax_incl *
                              Number(cur.quantity || 0) +
                            total,
                          0
                        )
                    );

                    setValue({
                      order_rows: or,
                      sum,
                    });
                  }
                : null
            }
          >
            <div
              className="d-flex justify-content-between align-items-center pb-2"
              style={{
                borderBottom: `1px solid ${
                  order_rows.length - 1 == idx ? "transparent" : "#D4E8FB"
                }`,
              }}
            >
              <div className="d-flex align-items-center text-sm">
                {setValue && type == "basic" && (
                  <CheckBoxInput
                    checked={order_rows_selected?.includes(d.id)}
                  />
                )}
                {type !== "basic" && (
                  <Tooltip placement="left" title={texts.tooltip_text}>
                    <IconDot className={texts.text_class} />
                  </Tooltip>
                )}
                <div
                  className="d-flex flex-column ml-3"
                  style={{
                    lineHeight: "16px",
                  }}
                >
                  <div>
                    {d.quantity}*
                    {have_product_reference(d.product_reference)
                      ? d.product_reference
                      : ""}
                  </div>
                  {d.product_name}
                  {order_rows_selected?.includes(d.id) && (
                    <div>
                      <Input
                        type="text"
                        value={productReferences[d.id] || ""}
                        onChange={(e) =>
                          handleInputChange(d.id, e.target.value)
                        }
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div>{returnEuroString(d.unit_price_tax_incl)}</div>
            </div>
            <div>
              {!!d.order_cart_rule_id && (
                <div className="text-warning text-xs">
                  The discount has already been applied:
                  <div>
                    {order_cart_rules
                      ?.filter(({ id }) => id == d.order_cart_rule_id)
                      ?.map(({ title, total }) => `${title}: ${total} €`)}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}
